import styles from '../../styles.module.css';
import { ReactNode } from 'react';
import ToggleButton from '../PlateCardHeader/ToggleButton';

type PlateCardProps = {
  open: boolean;
  onToggle?: () => void;
  children?: ReactNode;
  header?: ReactNode;
  aside?: ReactNode;
  showMoreButton?: boolean;
  className?: string;
  childClass?: string;
  plateBtnClass?: string;
};

export default function DropDownCard({
  open,
  onToggle,
  children,
  header,
  aside,
  showMoreButton = true,
  className = '',
  childClass = '',
  plateBtnClass = '',
}: PlateCardProps) {
  return (
    <div className={`${styles.plateCard} ${className}`} data-open={open}>
      <button className={`${styles.plateBtn} ${plateBtnClass}`} onClick={onToggle}>
        {header}
        {showMoreButton && (
          <div className={`${styles.headerLeft}`}>
            {aside}
            {onToggle && <ToggleButton open={open} />}
          </div>
        )}
      </button>

      {open && children && <div className={`${styles.detail} ${childClass}`}>{children}</div>}
    </div>
  );
}
